import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

function getArrow(forward, backward, upward) {
  if (forward) return <ArrowForwardIcon fontSize="inherit" />;
  if (backward) return <ArrowBackIcon fontSize="inherit" />;
  if (upward) return <ArrowUpwardIcon fontSize="inherit" />;
  return '';
}

function CustomLink({
  forward, backward, upward, noUnderline, href, children,
}) {
  const arrow = getArrow(forward, backward, upward);
  const underline = noUnderline ? 'none' : 'always';
  return (
    <>
      <Link
        underline={underline}
        color="textPrimary"
        href={href}
      >
        {children}
      </Link>
      <Link
        underline="none"
        color="textPrimary"
        href={href}
      >
        {arrow}
      </Link>
    </>
  );
}

CustomLink.propTypes = {
  forward: PropTypes.bool,
  backward: PropTypes.bool,
  upward: PropTypes.bool,
  noUnderline: PropTypes.bool,
  href: PropTypes.string,
  children: PropTypes.node,
};

CustomLink.defaultProps = {
  forward: false,
  backward: false,
  upward: false,
  noUnderline: false,
  href: undefined,
  children: undefined,
};

export default CustomLink;
